import styled from "styled-components"
import {useParams} from "react-router-dom"
import {useUpdateRole} from "hooks/query/role-query"
import {useForm} from "react-hook-form"
import {FormErrorBox} from "common/FormErrorBox"
import {NotificationType, showNotification} from "common/Notification"
import {useEffect} from "react"
import {useFindGroupById, useUpdateGroup} from "hooks/query/group-query"

export function UpdateGroupAttribute() {
    const {id} = useParams<{ id: string }>()
    const {data: group} = useFindGroupById(id)
    const mutate = useUpdateGroup()
    const attributes = group?.attributes || {}
    const deleteAttribute = (key: string) => {
        if (!group || !group.attributes) {
            showNotification("선택된 속성이 없습니다")
            return
        }
        if (!window.confirm("삭제하시겠습니까?")) return
        delete group.attributes[key]
        mutate.mutate(group, {
            onSuccess: () => showNotification("속성이 삭제되었습니다", NotificationType.SUCCESS),
            onError: () => showNotification("속성삭제를 실패했습니다")
        })
    }
    return (
        <>
            <Header className="flex flex-row mt-7 pb-3">
                <div className="basis-2/5">Key</div>
                <div className="basis-2/5">Value</div>
                <div className="basis-1/5">관리</div>
            </Header>
            {Object.keys(attributes).map(key => {
                const value = attributes[key]
                return (
                    <Body className="flex flex-row ">
                        <Item className="basis-2/5">{key}
                        </Item>
                        <Item className="basis-2/5">{value}
                        </Item>
                        <Item className="basis-1/5">
                            <button className="button is-danger is-small mt-3" onClick={() => deleteAttribute(key)}>
                                삭제
                            </button>
                        </Item>
                    </Body>
                )
            })}
            {id && (
                <UpdateAttributeForm id={id}/>
            )}
        </>
    )
}

type UpdateAttributeFormProps = {
    id: string
}

interface AttrValue {
    name: string
    value: string
}

const UpdateAttributeForm = ({id}: UpdateAttributeFormProps) => {
    const {register, handleSubmit, formState: {errors}, setValue, setFocus} = useForm<AttrValue>()
    const {data: group} = useFindGroupById(id)
    const mutate = useUpdateGroup()

    useEffect(() => {
        setFocus("name")
    }, [setFocus])
    const submit = (value: AttrValue) => {
        if (!group) {
            showNotification("선택된 Group이 없습니다")
            return
        }
        if (!group.attributes) {
            group.attributes = {}
        }
        group.attributes[value.name] = [value.value]
        mutate.mutate(group, {
            onSuccess: () => {
                showNotification("속성을 추가 했습니다", NotificationType.SUCCESS)
                setValue("name", "")
                setValue("value", "")
                setFocus("name")
            },
            onError: () => {
                showNotification("속성을 추가하지 못했습니다")
            }
        })
    }
    return (
        <form onSubmit={handleSubmit(submit)}>
            <Body className="flex flex-row">
                <Item className="basis-2/5">
                    <input className="input" placeholder="key를 입력하세요"
                           {...register("name", {required: "Key가 필요합니다"})}
                    />
                    <FormErrorBox error={errors.name}/>
                </Item>
                <Item className="basis-2/5">
                    <input className="input" placeholder="value를 입력하세요"
                           {...register("value", {required: "Value가 필요합니다"})}
                    />
                    <FormErrorBox error={errors.value}/>
                </Item>
                <Item className="basis-1/5 pt-2">
                    <button className="button is-link is-small mt-1">추가</button>
                </Item>
            </Body>
        </form>
    )
}

const Header = styled.div`
  vertical-align: middle;
  text-align: center;
  color: #a0aec0;
  font-size: .75rem;
  border: 0;
  background: #fff;
  border-bottom: 1px #E2E8F0 solid;
`

const Body = styled.div`
  vertical-align: middle;
  color: #666;
  font-size: 0.9rem;
  text-align: center !important;
  border-bottom: 1px solid #E2E8F0;
`

const Item = styled.div`
  text-align: center;
  line-height: 45px;
  min-height: 45px;
  font-weight: 400;
  vertical-align: middle;
  padding: 2px;
`